// extracted by mini-css-extract-plugin
export default {"root":"CustomersView_root__QMk+b","panel":"CustomersView_panel__89TYg","content":"CustomersView_content__kMuo+"};